﻿
// TCC and TronLogo origins from the environment config (StorefrontEmbedOrigins), space-separated on <body>.
function allowedMessageOrigins() {
    const value = document.body ? document.body.getAttribute("data-message-origins") : null;
    return value ? value.split(" ").filter(o => o) : [];
}

function isAllowedMessageOrigin(origin) {
    if (!origin || origin === "null") {
        return false;
    }

    if (origin === window.location.origin || allowedMessageOrigins().indexOf(origin) !== -1) {
        return true;
    }

    const shopHost = window.location.hostname;
    if (shopHost !== "localhost" && shopHost !== "127.0.0.1") {
        return false;
    }

    let hostname;
    try {
        hostname = new URL(origin).hostname;
    } catch (e) {
        return false;
    }

    return hostname === "localhost" || hostname === "127.0.0.1";
}

window.addEventListener("message", evt => {
    try {
        if (!isAllowedMessageOrigin(evt.origin)) {
            return;
        }

        if (typeof evt.data !== 'string') {
            return;
        }

        if (evt.data === "OpenInquiryPopup") {
            Component.openInquiryForm(evt);
            console.warn('Message with data "OpenInquiryPopup" is depricated, use {"action": "OpenInquiryPopup"} in data instead');
            return;
        }

        const jsonData = JSON.parse(evt.data);
        switch (jsonData.action) {
            case "OpenInquiryPopup":
                Component.openInquiryForm(evt);
                break;
            case "AddProductToCart":
                Component.addProductToCart(jsonData.data.productId, jsonData.data.quantity);
                break;
            case "AddProductWithCustomDataToCart":
                Component.addProductToCart(jsonData.data.productId, jsonData.data.quantity, jsonData.data.customData);
                break;
            case "ClosePopup":
                Component.closePopup(evt);
                break;
            default:
                console.warn(`Unsupported action! ACTION: ${jsonData.action}`);
        }

    } catch (e) {
        return false;
    }
});

window.openPopup = function (html) {
    console.log('OBSOLETE - use Component.openPopup');
    return Component.openPopup(html);
}

window.getAllowedCookies = function(){
    console.log('OBSOLETE - use Component.getAllowedCookies');
    return Component.getAllowedCookies();
}

window.getCookie = function (cookieName) {
    console.log('OBSOLETE - use Component.getCookie');
    return Component.getCookie(cookieName);
}

